import React from 'react';
import PropTypes from 'prop-types';
import './WorkExprience.scss';

const rootClass = 'work-exprience';

const Projects = ({ project }) => {
	const nodeClass = `${rootClass}__section__exp`;
	const { name, description, roles }= project;
	const roleList = roles.map((role, idx) => <li key={idx}>{role}</li>)
	return (
		<React.Fragment>
			<div className={`${nodeClass}__project`}><strong>Project: </strong>{name}</div>
				<div className={`${nodeClass}__description`}>
					{description}
				</div>
				<div className={`${nodeClass}__responsibility`}>
					<div className={`${nodeClass}__responsibility__label`}>Responsility</div>
					<ul>
						{roleList}
					</ul>
			</div>
		</React.Fragment>
	)
}

export const Exprience = ({ exprience }) => {
	const nodeClass = `${rootClass}__section__exp`;
	const { title, organization, projects } = exprience;
	const projectList = projects.map((project, idx) => <Projects project={project} key={idx} />);
	return (
		<div className={nodeClass}>
			<div className={`${nodeClass}__role`}>{title} <span className="badge">{organization}</span></div>
			{projectList}
		</div>
	)
}

const WorkExprience = ({ workExprience }) => {
	const exprienceList = workExprience.map((exprience, idx)=> <Exprience exprience={exprience} key={idx} />)

	return (
		<div className={rootClass}>
			<h2 className={`${rootClass}__title`}>
				Work Exprience
			</h2>
			<div className={`${rootClass}__section`}>
				{exprienceList}
			</div>
		</div>
	);
};

WorkExprience.propTypes = {
	workExprience: PropTypes.array,
};

export default WorkExprience;